module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAASElEQVQ4y2P4jwQ+MAww7wADDNgPAh7zfwYG/j+Dgwd2FFBoEPD4//8fPDxgACFCaYB54ESM5M4B5AHdBUlCg4M3WPL04CnrAFr6rW/L4OhZAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQzKzA5OjAweQ3b9QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00203_100x100.png
// module id = dYTH
// module chunks = 0